interface CurrentUserRoleFlags {
  isSuperAdminRole?: boolean;
  isDoctorRole?: boolean;
}

/**
 * No.176: message templates (view/create/edit/delete, incl. the chat template
 * picker) are restricted to super_admin and doctor — clinic_admin, cs and
 * pharmacist have no access at all (customer-confirmed 2026-10-12). The
 * backend rejects any other role with a 400 (see routes/api.managers.php in
 * sheepmedical-api), so the FE must gate every call site, not just the
 * management screen route.
 */
export function canUseMessageTemplate(
  currentUser: CurrentUserRoleFlags | null | undefined,
): boolean {
  return !!currentUser?.isSuperAdminRole || !!currentUser?.isDoctorRole;
}
